var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleCallingVoiceCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F9F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2648 9.6665C11.5757 9.6665 10.9149 9.94022 10.4277 10.4275C9.94047 10.9147 9.66675 11.5755 9.66675 12.2645C9.66675 12.2814 9.66726 12.2983 9.66828 12.3151C9.88979 15.9601 11.4376 19.398 14.0198 21.9801C16.6019 24.5623 20.0398 26.1101 23.6848 26.3316C23.7017 26.3327 23.7185 26.3332 23.7354 26.3332C24.4244 26.3332 25.0852 26.0595 25.5725 25.5722C26.0597 25.085 26.3334 24.4242 26.3334 23.7351V21.3341C26.3334 20.3118 25.711 19.3926 24.7619 19.0129L22.5453 18.1263C21.5042 17.7099 20.3148 18.1105 19.7379 19.0721C19.5547 19.3773 19.2448 19.3984 19.0782 19.2855C18.1477 18.6545 17.3454 17.8522 16.7145 16.9217C16.6015 16.7552 16.6226 16.4452 16.9278 16.2621C17.8894 15.6851 18.2901 14.4957 17.8736 13.4546L16.987 11.238C16.6073 10.2889 15.6881 9.6665 14.6658 9.6665H12.2648Z",
    fill: "#1E2131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleCallingVoiceCall);
export default __webpack_public_path__ + "static/media/people-calling-voice-call.fa2ede806bc07d9de17285281b40012a.svg";
export { ForwardRef as ReactComponent };